// extracted by mini-css-extract-plugin
module.exports = {"statusError":"StatusTableCellValue_statusError__RtAcv","statusOk":"StatusTableCellValue_statusOk__3JUCI","root":"StatusTableCellValue_root__1hCdE"};